/* ==========================================================================
   AutocompleteRxjs > Client > Config
   ========================================================================== */

/* Import modules */
const { css } = require('../../../input-rxjs/client/js/config')();

/* Config */
const config = {
    component: 'AutocompleteRxjs',
    init: true,
    start: true,
    selectionRange: true,
    hasAllAirpots: true,
    css: {
        active: css.active,
        alternative: css.alternative,
        disabled: css.disabled,
        error: css.error,
        header: 'autocomplete-rxjs__header',
        hidden: css.hidden,
        keyed: 'is-keyed',
        suggestion: 'autocomplete-rxjs__suggestion',
        valid: css.valid,
        withBorder: css.withBorder,
        loading: 'is-loading'
    },
    type: {
        tooltip: 'autocomplete-suggestion-panel'
    },
    hooks: {
        panelContent: 'data-ui-panel-content',
        suggestion: 'data-suggestions',
        suggestionsList: 'data-list'
    }
};

module.exports = () => config;
